import {
  ApplicationRef,
  createComponent,
  EmbeddedViewRef,
  EnvironmentInjector,
  inject,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';

import _ from 'lodash';
import { Subject } from 'rxjs';

@Injectable()
export class ModalService {
  private readonly appRef = inject(ApplicationRef);
  private readonly environmentInjector = inject(EnvironmentInjector);

  create<T>(config: SpaModalConfig): SpaModal<T> {
    const { comp, data } = config;

    const subject = new Subject<T | undefined>();

    const closeDialog = (res?: T) => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
      subject.next(res);
    };

    const modal: SpaModal<T> = {
      close: closeDialog,
      onClose: subject,
    };

    const elementInjector = Injector.create({
      providers: [{ provide: SPA_DIALOG, useValue: modal }],
      parent: this.environmentInjector,
    });
    const componentRef = createComponent(comp, {
      elementInjector,
      environmentInjector: this.environmentInjector,
    });

    _.forOwn(data, (value, key) => {
      componentRef.setInput(key, value);
    });

    this.appRef.attachView(componentRef.hostView);
    componentRef.changeDetectorRef.detectChanges();

    const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);

    return modal;
  }
}

export const SPA_DIALOG = new InjectionToken<string>('SPA_DIALOG');

export interface SpaModalConfig {
  comp: Type<unknown>;
  data?: unknown;
}

export interface SpaModal<T> {
  onClose: Subject<T | undefined>;
  close: (res?: T) => void;
}
